"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamType = void 0;
var StreamType;
(function (StreamType) {
    StreamType["TRANSACTIONAL"] = "TRANSACTIONAL";
    StreamType["BROADCAST"] = "BROADCAST";
})(StreamType = exports.StreamType || (exports.StreamType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW1haWwtZXZlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZXZlbnRzL2VtYWlsLWV2ZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUtBLElBQVksVUFHWDtBQUhELFdBQVksVUFBVTtJQUNwQiw2Q0FBK0IsQ0FBQTtJQUMvQixxQ0FBdUIsQ0FBQTtBQUN6QixDQUFDLEVBSFcsVUFBVSxHQUFWLGtCQUFVLEtBQVYsa0JBQVUsUUFHckIifQ==